import FW from '../fw/fw';


export default class ColorsManagement {

  #rmp;

  constructor(rmp) {
    this.#rmp = rmp;
  }

  #backgroundColor() {
    const skinBackgroundColor = this.#rmp.skinBackgroundColor;
    let css = '.rmp-s1 .rmp-color-bg,' +
      '.rmp-s1 .rmp-module-overlay-icons,' +
      '.rmp-s1 .rmp-related-title,' +
      '.rmp-s1 .rmp-related-duration,' +
      '.rmp-s1.rmp-playlist-side-menu,' +
      '.rmp-s2.rmp-playlist-side-menu,' +
      '.rmp-s1.rmp-transcripts-side-menu,' +
      '.rmp-s2.rmp-transcripts-side-menu' +
      '{background: ' + skinBackgroundColor + ';}';

    css += '.rmp-s1 .rmp-overlay-level' +
      '{border-color: ' + skinBackgroundColor + ';}';

    css += '.rmp-s1 .rmp-overlay-level-active' +
      '{color: ' + skinBackgroundColor + ';}';

    FW.appendStyle(css, this.#rmp.shadowRoot);
  }

  #buttonColor() {
    const skinButtonColor = this.#rmp.skinButtonColor;
    let css = '.rmp-color-button,' +
      '.rmp-loading-spin-circle,' +
      '.rmp-control-bar-hint,' +
      '.rmp-time-elapsed-text,' +
      '.rmp-duration-text,' +
      '.rmp-module-hint,' +
      '.rmp-quality-hd,' +
      '.rmp-related-skip-preview-up-next,' +
      '.rmp-transcripts-item-active:hover,' +
      '.rmp-related-skip-preview-title' +
      '{color: ' + skinButtonColor + ';}';

    css += '.rmp-color-bg-sliding,' +
      '.rmp-volume-bar-sliding-current-position,' +
      '.rmp-audio-only-loading-spin::after,' +
      '.rmp-s2 .rmp-ad-markers,' +
      '.rmp-s2 .rmp-cue-point' +
      '{background: ' + skinButtonColor + ';}';

    css += '.rmp-module-fcc-settings, ' +
      '.rmp-loading-spin-circle,' +
      '.rmp-quality-indicator,' +
      '.rmp-transcripts-header,' +
      '.rmp-playlist-header,' +
      '.rmp-playlist-item,' +
      '.rmp-s2 .rmp-overlay-level-active.rmp-abr-active,' +
      '.rmp-s2 .rmp-seek-bar-sliding-area' +
      '{border-color: ' + skinButtonColor + ';}';

    css += '.rmp-s1 .rmp-overlay-level-active,' +
      '.rmp-s2 .rmp-overlay-level-active' +
      '{background: ' + skinButtonColor + '; border-color: ' + skinButtonColor + ';}';

    FW.appendStyle(css, this.#rmp.shadowRoot);
  }

  #accentColor() {
    const skinAccentColor = this.#rmp.skinAccentColor;
    let css = '.rmp-color-accent,' +
      '.rmp-overlay-level:hover:not(.rmp-overlay-level-active),' +
      '.rmp-i:hover,' +
      '.rmp-module:hover .rmp-i,' +
      '.rmp-ad-info-message,' +
      '.rmp-sup,' +
      '.rmp-transcripts-item:hover:not(.rmp-transcripts-item-active),' +
      '.rmp-pip-on .rmp-i-pip,' +
      '.rmp-theater-on .rmp-i-theater,' +
      '.rmp-loading-spin-circle::after,' +
      '.rmp-related-item-active,' +
      '.rmp-related-item:hover .rmp-related-title,' +
      '.rmp-related-item:hover .rmp-related-duration,' +
      '.rmp-s2 .rmp-overlay-level:hover:not(.rmp-overlay-level-active),' +
      '.rmp-s2 .rmp-overlay-level-active' +
      '{color: ' + skinAccentColor + ';}';

    css += '.rmp-ad-current-time,' +
      '.rmp-quality-hd,' +
      '.rmp-cue-point,' +
      '.rmp-playlist-item:hover,' +
      '.rmp-playlist-item-active,' +
      '.rmp-transcripts-item-active,' +
      '.rmp-dvr.rmp-dvr-vod .rmp-time-elapsed-text:hover,' +
      '.rmp-s1 .rmp-ad-markers,' +
      '.rmp-s2 .rmp-volume-bar-sliding-handle,' +
      '.rmp-s2 .rmp-volume-bar-sliding-current-position,' +
      '.rmp-s2 .rmp-seek-bar-sliding-handle,' +
      '.rmp-s2 .rmp-seek-bar-sliding-current-position' +
      '{background: ' + skinAccentColor + ';}';

    css += '.rmp-abr-active, .rmp-button.rmp-overlay-level.rmp-abr-active' +
      '{border-color: ' + skinAccentColor + ';}';

    css += '.rmp-loading-spin-circle' +
      '{border-bottom-color: ' + skinAccentColor + ';}';

    css += '.rmp-module-fcc-settings:hover' +
      '{border-color: ' + skinAccentColor + '; color: ' + skinAccentColor + ';}';

    css += '.rmp-related-item-active, .rmp-module-overlay-icons-active' +
      '{box-shadow: 0 0 0 3px ' + skinAccentColor + ';}';

    const rgbColor = FW.hexToRgb(skinAccentColor);
    if (rgbColor) {
      css += '.rmp-dvr.rmp-dvr-vod .rmp-time-elapsed-text' +
        '{background: rgba(' + rgbColor.r + ',' + rgbColor.g + ',' + rgbColor.b + ',0.9);}';
    }

    FW.appendStyle(css, this.#rmp.shadowRoot);
  }

  applySkinColors() {
    if (this.#rmp.skinBackgroundColor !== '') {
      if (this.#rmp.skinBackgroundColor.indexOf('rgba') === -1) {
        this.#rmp.skinBackgroundColor = '#' + this.#rmp.skinBackgroundColor;
      }
      this.#backgroundColor();
    }
    if (this.#rmp.skinButtonColor !== '') {
      if (this.#rmp.skinButtonColor.indexOf('rgba') === -1) {
        this.#rmp.skinButtonColor = '#' + this.#rmp.skinButtonColor;
      }
      this.#buttonColor();
    }
    if (this.#rmp.skinAccentColor !== '') {
      if (this.#rmp.skinAccentColor.indexOf('rgba') === -1) {
        this.#rmp.skinAccentColor = '#' + this.#rmp.skinAccentColor;
      }
      this.#accentColor();
    }
    if (this.#rmp.googleCast) {
      if (this.#rmp.skinButtonColor === '') {
        this.#rmp.skinButtonColor = 'rgba(255, 255, 255, 1)';
      }
      if (this.#rmp.skinAccentColor === '') {
        this.#rmp.skinAccentColor = 'rgba(130, 177, 255, 1)';
      }
      let css = 'google-cast-launcher' +
        '{--disconnected-color: ' + this.#rmp.skinButtonColor +
        ';--connected-color: ' + this.#rmp.skinAccentColor + ';}';
      if (this.#rmp.customIconsLoc === '') {
        css += 'google-cast-launcher:hover' +
          '{--disconnected-color: ' + this.#rmp.skinAccentColor + ';}';
      }
      FW.appendStyle(css, this.#rmp.shadowRoot);
    }
  }

}
